import { render } from "./UpSell.vue?vue&type=template&id=289d353b"
import script from "./UpSell.vue?vue&type=script&lang=js"
export * from "./UpSell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__